export var sizes = ['small', 'big'];
export var themes = ['default', 'b2c', 'b2b'];